import { createFileRoute } from '@tanstack/react-router';

import { EProd } from '@/view/pages/EProd';

export const Route = createFileRoute('/_protected/$programId/eprod/')({
  component: EProd,
  context: (context): { title: string } => ({
    ...context,
    title: 'E-prod',
  }),
});
